import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';

import PageHvnDnsForwardingCreate from 'hcp/components/page/hvn-dns-forwarding/create';

<template>
  {{pageTitle (t "page-title.hvn-custom-dns-forwarding.create")}}

  <PageHvnDnsForwardingCreate @model={{@model}} />
</template>
